import { FlatList } from 'react-native';
import LinearGradient from 'react-native-linear-gradient';
import { ActivityIndicator } from 'react-native-paper';
import { Button } from 'react-native-paper';
import styled from 'styled-components/native';

import Image from '@src/components/Image';
import ImageBackground from '@src/components/ImageBackground';
import Separator from '@src/components/Separator';
import {
  idKeyExtractor,
  maxWidth,
  padding,
} from '@src/configuration/constants';
import { Journey, Post } from '@src/types';

const BUTTON_WIDTH = maxWidth * 0.1;

export const Container = styled.View``;

export const Gradient = styled(LinearGradient)`
  height: 100%;
  transform: translateY(1px);
`;

export const Background = styled(ImageBackground)`
  width: 100%;
  height: 250px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
`;

export const Title = styled.View`
  margin-top: 160px;
  padding: 0 ${padding}px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const Credit = styled.View`
  padding: 10px ${padding}px 0px;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
`;

export const Section = styled.View`
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const UserInfoSection = styled.View`
  flex-direction: column;
  justify-content: space-evenly;
  align-items: flex-end;
`;

export const RowSection = styled.View`
  flex-direction: row;
  align-items: center;
`;

export const Badge = styled(Image)`
  width: 48px;
  height: 48px;
`;

export const BaseButton = styled(Button)`
  min-width: ${BUTTON_WIDTH}px;
  margin-horizontal: ${padding / 2}px;
`;

export const FollowButton = styled(BaseButton).attrs(() => ({
  uppercase: false,
  mode: 'text',
}))``;

export const BlockButton = styled(BaseButton).attrs(({ theme }) => ({
  uppercase: false,
  mode: 'text',
  color: theme.colors.error,
}))``;

// export const CancelRequestButton = styled(BaseButton).attrs(({ theme }) => ({
//   uppercase: false,
//   mode: 'outlined',
//   labelStyle: {
//     color: theme.colors.onSurface,
//   },
// }))``;

export const UnfollowButton = styled(BaseButton).attrs(({ theme }) => ({
  uppercase: false,
  mode: 'text',
  color: theme.colors.error,
}))``;

export const EditButton = styled(BaseButton).attrs(() => ({
  uppercase: false,
  mode: 'text',
}))``;

export const Spinner = styled(ActivityIndicator)`
  align-self: center;
  margin-horizontal: ${padding}px;
`;

export const List = styled(FlatList as new () => FlatList<Post>).attrs(() => ({
  removeClippedSubviews: true,
  scrollEventThrottle: 8,
  initialNumToRender: 1,
  maxToRenderPerBatch: 1,
  keyExtractor: idKeyExtractor,
  ItemSeparatorComponent: Separator,
  contentContainerStyle: {
    paddingBottom: padding,
    maxWidth: maxWidth,
  },
}))``;

export const JourneysList = styled(
  FlatList as new () => FlatList<Journey>
).attrs(() => ({
  horizontal: true,
  removeClippedSubviews: true,
  initialNumToRender: 6,
  keyExtractor: idKeyExtractor,
  showsHorizontalScrollIndicator: false,
  ItemSeparatorComponent: Separator,
  contentContainerStyle: {
    paddingHorizontal: padding,
    paddingVertical: padding / 2,
  },
}))`
  margin-bottom: ${padding}px;
`;

export const ListFooter = styled.View`
  height: 80px;
`;
